package kz.dentalcrm.app.screens.service_categories.edit.mvi

import kz.dentalcrm.app.core.base.ViewEvent
import kz.dentalcrm.app.data.network.response_model.services_category.ServiceCategory

sealed interface EditServiceCategoryViewEvent : ViewEvent {
    data class EditCategory(val category: ServiceCategory, val name: String) : EditServiceCategoryViewEvent
    data class DeleteCategory(val category: ServiceCategory) : EditServiceCategoryViewEvent
    data object Reset : EditServiceCategoryViewEvent
}
